/**
 * Shared "session is over" handler: clear JWT tokens and send the browser to the login page.
 */
import axios from 'axios';
import { AUTH_ROUTES } from '@features/auth/constants';
import { tokenService } from './tokenService';

export const getLoginUrl = (): string => {
  const destination = `${window.location.pathname}${window.location.search}`;

  return `${AUTH_ROUTES.LOGIN}?destination=${encodeURIComponent(destination)}`;
};

/**
 * Only a 401 from the refresh endpoint is definitive. Network errors, timeouts and 5xx are
 * transient and must not log the user out - the next attempt retries.
 */
export const isSessionOver = (error: unknown): boolean =>
  axios.isAxiosError(error) && error.response?.status === 401;

/**
 * Rotation blacklists the old token pair, so a refresh that lost a race gets the same 401 as an
 * expired session. A changed stored token means another refresher succeeded - do not log out.
 */
export const isRotatedElsewhere = (sentRefreshToken: string): boolean => {
  const currentRefreshToken = tokenService.getRefreshToken();

  return currentRefreshToken !== null && currentRefreshToken !== sentRefreshToken;
};

export const redirectToLogin = (): void => {
  const loginUrl = getLoginUrl();

  tokenService.clearTokens();
  window.location.href = loginUrl;
};

export default redirectToLogin;
